<template>
<section class="contact padding sectionScroll" id="sectionScroll4">
  <div class="container">
    <div class="row">
      <div class="info">
        <div class="logo">
          <span class="animation a-translateX">
            <svg width="46" height="53" viewBox="0 0 46 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 13.25L22.8973 0L45.8029 13.25L46 39.6374L22.8973 53L0 39.75V13.25ZM4.57684 18.7272V29.2345L11.9004 33.3403V41.1048L20.6023 46.1779V27.9078L4.57684 18.7272ZM41.2408 18.7272L25.2153 27.9062V46.1762L33.909 41.1032V33.3486L41.2425 29.2345L41.2408 18.7272ZM6.86197 14.5783L22.8628 23.7307L38.8965 14.5005L30.4181 9.64434L22.9483 13.9407L15.4357 9.593L6.86197 14.5783Z" fill="white"/>
          </svg>
          </span>
          <span class="animation a-translateY">SolarBox</span>
        </div>
        <small v-if="HEADER_LANG === 'en'" class="animation a-translateX a-tr-2">ADDRESS</small>
        <small v-if="HEADER_LANG === 'ru'" class="animation a-translateX a-tr-2">АДРЕС</small>
        <p class="animation a-translateX a-tr-3">971 Timber Wolf Trail undefined Stamford, Delaware 90039 United States</p>
        <small v-if="HEADER_LANG === 'en'" class="animation a-translateX a-tr-4">MAIL</small>
        <small v-if="HEADER_LANG === 'ru'" class="animation a-translateX a-tr-4">ЭЛЕКТРОННАЯ ПОЧТА</small>
        <span class="animation a-translateX a-tr-5"><a href="mailto:info@solarbxx.com">info@solarbxx.com</a></span>
      </div>
      <div class="links animation a-translateY a-tr-6">
        <a href="#" class="link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 19.253906 2 C 15.311906 2 13 4.0821719 13 8.8261719 L 13 13 L 8 13 L 8 18 L 13 18 L 13 30 L 18 30 L 18 18 L 22 18 L 23 13 L 18 13 L 18 9.671875 C 18 7.884875 18.582766 7 20.259766 7 L 23 7 L 23 2.2050781 C 22.526 2.1410781 21.144906 2 19.253906 2 z"/></svg>
        </a>
        <a href="#" class="link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 28 8.558594 C 27.117188 8.949219 26.167969 9.214844 25.171875 9.332031 C 26.1875 8.722656 26.96875 7.757813 27.335938 6.609375 C 26.386719 7.171875 25.332031 7.582031 24.210938 7.804688 C 23.3125 6.847656 22.03125 6.246094 20.617188 6.246094 C 17.898438 6.246094 15.691406 8.453125 15.691406 11.171875 C 15.691406 11.558594 15.734375 11.933594 15.820313 12.292969 C 11.726563 12.089844 8.097656 10.128906 5.671875 7.148438 C 5.246094 7.875 5.003906 8.722656 5.003906 9.625 C 5.003906 11.332031 5.871094 12.839844 7.195313 13.722656 C 6.386719 13.695313 5.628906 13.476563 4.964844 13.105469 C 4.964844 13.128906 4.964844 13.148438 4.964844 13.167969 C 4.964844 15.554688 6.660156 17.546875 8.914063 17.996094 C 8.5 18.109375 8.066406 18.171875 7.617188 18.171875 C 7.300781 18.171875 6.988281 18.140625 6.691406 18.082031 C 7.316406 20.039063 9.136719 21.460938 11.289063 21.503906 C 9.605469 22.824219 7.480469 23.609375 5.175781 23.609375 C 4.777344 23.609375 4.386719 23.585938 4 23.539063 C 6.179688 24.9375 8.765625 25.753906 11.546875 25.753906 C 20.605469 25.753906 25.558594 18.25 25.558594 11.742188 C 25.558594 11.53125 25.550781 11.316406 25.542969 11.105469 C 26.503906 10.410156 27.339844 9.542969 28 8.558594 Z"/></svg>
        </a>
        <a href="#" class="link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 8.6425781 4 C 7.1835781 4 6 5.181625 6 6.640625 C 6 8.099625 7.182625 9.3085938 8.640625 9.3085938 C 10.098625 9.3085938 11.283203 8.099625 11.283203 6.640625 C 11.283203 5.182625 10.101578 4 8.6425781 4 z M 21.535156 11 C 19.316156 11 18.0465 12.160453 17.4375 13.314453 L 17.373047 13.314453 L 17.373047 11.310547 L 13 11.310547 L 13 26 L 17.556641 26 L 17.556641 18.728516 C 17.556641 16.812516 17.701266 14.960938 20.072266 14.960938 C 22.409266 14.960937 22.443359 17.145609 22.443359 18.849609 L 22.443359 26 L 26.994141 26 L 27 26 L 27 17.931641 C 27 13.983641 26.151156 11 21.535156 11 z M 6.3632812 11.310547 L 6.3632812 26 L 10.923828 26 L 10.923828 11.310547 L 6.3632812 11.310547 z"/></svg>
        </a>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionContact',
  components: {},
  methods: {},
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.contact {
  background-color: $cBlack;
  .info {
    .logo {
      font-weight: bold;
      font-size: 3rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 40px;
      span {
        color: $cRed;
        margin-left: 20px;
      }
      path {
        fill: $cRed;
      }
    }
    small {
      display: block;
      font-weight: bold;
      font-size: 1rem;
      color: $cYellow;
      margin-bottom: 10px;
    }
    p {
      color: $cWhite;
      max-width: 300px;
      margin-bottom: 30px;
    }
    a {
      color: $cWhite;
      transition: .1s linear all;
      text-decoration: underline transparent;
      &:hover {
        color: $cRed;
        text-decoration: underline $cRed;
      }
      &:active {
        opacity: .6;
      }
    }
  }
  .links {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .link {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      background-color: $cGrey;
      margin-right: 20px;
      transition: .1s linear all;
      &:last-child {
        margin-right: 0;
      }
      svg {
        width: 60%;
        height: 60%;
        object-position: center;
        object-fit: contain;
        path {
          fill: $cWhite;
        }
      }
      &:hover {
        background-color: $cRed;
      }
      &:active {
        opacity: .6;
      }
    }
  }
}
</style>
